import { gql } from '@apollo/client';

export const AddPreApprovalDocument = gql`
  mutation AddPreApprovalDocument($offerId: String!, $s3Key: String!, $name: String!) {
    buyer {
      addPreApprovalDocumentByOfferId(input: { offerId: $offerId, s3Key: $s3Key, name: $name }) {
        document {
          id
          fileScanStatus
          name
          url
        }
      }
    }
  }
`;
